export default __webpack_public_path__ + "static/media/bad.9b38ab1b.png";